var _path, _path2;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgFlechaOrdenarAbajo16X16(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M7.10368 1.97522C7.54222 1.35852 8.45804 1.35852 8.89658 1.97522L11.6891 5.9022C11.8811 6.17226 11.8179 6.54685 11.5478 6.73889C11.2778 6.93093 10.9032 6.86768 10.7112 6.59763L8.00013 2.78525L5.28911 6.59763C5.09707 6.86768 4.72247 6.93093 4.45242 6.73889C4.18237 6.54685 4.11912 6.17226 4.31116 5.9022L7.10368 1.97522Z",
    fill: "#CFD3D8"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M8.89621 14.0246C8.45766 14.6413 7.54184 14.6413 7.1033 14.0246L4.31078 10.0976C4.11874 9.82758 4.18199 9.45298 4.45204 9.26094C4.72209 9.06891 5.09669 9.13215 5.28873 9.4022L7.99975 13.2146L10.7108 9.4022C10.9028 9.13215 11.2774 9.06891 11.5475 9.26094C11.8175 9.45298 11.8808 9.82758 11.6887 10.0976L8.89621 14.0246Z",
    fill: "#F07B43"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFlechaOrdenarAbajo16X16);
export default __webpack_public_path__ + "static/media/FLECHA_ORDENAR_ABAJO_16X16.314cd63ff5cace8f217d18208fb83c88.svg";
export { ForwardRef as ReactComponent };